import { ActionTypes } from 'utils/constants';

export const series = (state = {}, action) => {
    switch(action.type) {
        case ActionTypes.FETCH_SERIES + '_PENDING': {
            return {
                ...state,
                fetching: true
            };
        }
        case ActionTypes.FETCH_SERIES + '_REJECTED': {
            return {
                ...state,
                fetching: false,
                error: true
            };
        }
        case ActionTypes.FETCH_SERIES + '_FULFILLED': {
            return {
                ...state,
                fetching: false,
                fetched: true,
                series: action.payload?.data?.series || []
            };
        }
        default: {
            return state;
        }
    }
};
